import { timeStatus } from "helpers/timeStatus";
import { orderTypes } from "./orderTypes";
import { cleanObject } from "helpers/validateObject";
import { formatCustomDate } from "helpers/dateTools";
import { orderArrayV2 } from "helpers/orderArray";
import { cleanNumber } from "helpers/cleanNumbers";
import { statusOrder } from "helpers/statusVariable";

const {
  SET_FILTERS_PARAMS,
  GET_ORDERS,
  SELECT_ORDER,
  FILTER_ORDERS,
  SET_ORDER_SCHEDULE,
  SET_ORDER_CAUSES,
  EDIT_ORDER,
  ADD_COMMENT,
  SET_COUPON_ORDER,
  RESTORE_INITIAL,
  GET_SERVICE_DETAILS,
  SET_NEW_PAYMENT_LINK,
  ADD_ETA
} = orderTypes
const { ON_TIME, DELAYED, LATE, FINISHED } = timeStatus

const initialState = {
  startDate: formatCustomDate(new Date(), "-"),
  endDate: formatCustomDate(new Date(), "-"),
  stations: [],
  company: [],
  filter: { value: 'stations', label: 'Plantas' },
  orders: [],
  order: {},
  orderDetails: {},
  causes: [],
  schedules: [],
  temp: {
    ON_TIME: [],
    DELAYED: [],
    LATE: [],
    FINISHED: [],
  },
  timing: {
    ON_TIME: true,
    DELAYED: true,
    LATE: true,
    FINISHED: true,
  },
};

export const splitTimingOrders = (data) => {
  let orders = {
    [ON_TIME.value]: [],
    [DELAYED.value]: [],
    [LATE.value]: [],
    [FINISHED.value]: [],
  };

  data.forEach((order) => {
    if (Object.prototype.hasOwnProperty.call(orders, order.timing)) {
      orders[order.timing].push(order);
    } else {
      orders[order.timing] = [order];
    }
  });

  return orders;
};

export const ordersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FILTERS_PARAMS:
      return {
        ...state,
        ...payload,
      };
    case GET_ORDERS:
      const newPayload = payload.map((order) => {
        const clean = cleanObject(order);
        const orderStatus = statusOrder[order.status];
        return {
          ...clean,
          nTotal: cleanNumber(clean.total),
          nStatus:
            !order.unit && !["CANCELED", "DONE"].includes(order.status)
              ? "Sin asignar"
              : orderStatus?.label || order.status || "Desconocido",
          colorStatus: order.unit ? (orderStatus?.color || "gray") : "orange",
        };
      });
      const sortNewPayload = orderArrayV2(newPayload, "date", true);
      const orders = splitTimingOrders(sortNewPayload);
      return {
        ...state,
        orders: sortNewPayload,
        temp: orders,
        timing: {
          ...initialState.timing,
        },
      };

    case SELECT_ORDER:
      return {
        ...state,
        order: payload,
      };
    case FILTER_ORDERS:
      let newTiming = { ...state.timing };
      newTiming[payload] = !newTiming[payload];
      const on_time = newTiming.ON_TIME ? state.temp.ON_TIME : [];
      const delayed = newTiming.DELAYED ? state.temp.DELAYED : [];
      const late = newTiming.LATE ? state.temp.LATE : [];
      const finished = newTiming.FINISHED ? state.temp.FINISHED : [];
      const fOrders = [...on_time, ...delayed, ...late, ...finished];
      return {
        ...state,
        timing: newTiming,
        orders: fOrders,
      };
    case SET_ORDER_SCHEDULE:
      const newSchedules = payload.map((sch) => {
        const nSchedules = sch.schedules.map((schedule) => {
          return {
            ...schedule,
            label: `${schedule.start} - ${schedule.end}`,
            value: schedule.id,
          };
        });
        return {
          ...sch,
          label: sch.date,
          value: sch.date,
          schedules: nSchedules,
        };
      });
      return {
        ...state,
        schedules: newSchedules,
      };

    case SET_ORDER_CAUSES:
      const causes = payload.map((cause) => {
        return {
          ...cause,
          label: `${cause.responsible}: ${cause.name}`,
          value: cause.id,
        };
      });
      const sortCauses = orderArrayV2(causes, "label");
      return {
        ...state,
        causes: sortCauses,
      };

    case EDIT_ORDER:
      const sDate = state.startDate;
      const eDate = state.endDate;
      const editStateOrders = [...state.orders];
      // _formIsAsap es solo un fallback del formulario: se extrae para no
      // persistirlo en el estado y mantener el order limpio.
      const { _formIsAsap, ...editPayload } = payload;
      const editStatus = statusOrder[editPayload.status];
      if (editPayload.date >= sDate && editPayload.date <= eDate) {
        const orderIdx = editStateOrders.findIndex(
          (order) => order.id === editPayload.id,
        );
        if (orderIdx >= 0) {
          const originalOrder = editStateOrders[orderIdx];
          const updatedServiceComplement = {
            ...originalOrder.serviceComplement,
            // Prioriza el valor del backend; si no viene, usa el del
            // formulario y por último conserva el original.
            isAsap:
              editPayload.serviceComplement?.isAsap ??
              _formIsAsap ??
              originalOrder.serviceComplement?.isAsap,
          };
          editStateOrders[orderIdx] = {
            ...editPayload,
            serviceComplement: updatedServiceComplement,
            nStatus: editStatus?.label || editPayload.status || "Desconocido",
            colorStatus: editStatus?.color || "gray",
          };
          const edited = splitTimingOrders(editStateOrders);
          return {
            ...state,
            orders: editStateOrders,
            temp: edited,
            order: {
              ...editPayload,
              serviceComplement: updatedServiceComplement,
            },
          };
        }
        return state;
      }
      const newOrders = editStateOrders.filter(
        (order) => order.id !== editPayload.id,
      );
      return {
        ...state,
        orders: newOrders,
        temp: splitTimingOrders(newOrders),
      };
    case ADD_COMMENT:
      const ordersCommentsState = [...state.orders];
      const orderCommentIdx = ordersCommentsState.findIndex(
        (order) => order.id === payload.id,
      );
      if (orderCommentIdx >= 0) {
        const commentStatus = statusOrder[payload.status];
        ordersCommentsState[orderCommentIdx] = {
          ...payload,
          nStatus: commentStatus?.label || payload.status || "Desconocido",
          colorStatus: commentStatus?.color || "gray",
        };
        return {
          ...state,
          orders: ordersCommentsState,
          order: payload,
        };
      }

      return state;

    case SET_COUPON_ORDER:
      const nOrders = [...state.orders];
      const idx = nOrders.findIndex((a) => a.id === payload.id);
      nOrders[idx].coupon = payload.coupon;
      return {
        ...state,
        temp: splitTimingOrders(nOrders)
      }
    case GET_SERVICE_DETAILS:
      return {
        ...state,
        orderDetails: payload
      }
    case SET_NEW_PAYMENT_LINK:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          payments: [...(state.orderDetails?.payments || []), payload]
        }
      }
    case RESTORE_INITIAL:
      return initialState;
    case ADD_ETA:
      return {
        ...state,
        order: {
          ...state.order,
          eta: payload.eta,
        },
      };
    default:
      return state;
  }
};
